import { useSelector } from 'react-redux';
import { Avatar, Menu, MenuItem } from '@progress/kendo-react-layout';
import './profile-menu.css';
import { getRole, selectUserInitials, selectUserName } from '../../reducers/user/selectors';
import routes from '../../constants/routes.json';
import { useNavigate } from 'react-router-dom';
import { Roles } from '../../constants/app';
import { OPEN_KEYBOARD_SHORTCUTS_EVENT } from '../keyboard/events';

const ProfileMenu = () => {
  const user = useSelector(selectUserName);
  const initials = useSelector(selectUserInitials);
  const navigate = useNavigate();
  const role = useSelector(getRole);

  const onSelect = (event: any): void => {
    const { route, action } = event.item.data || {};
    if (route) {
      navigate(route);
    } else if (action === 'shortcuts') {
      window.dispatchEvent(new CustomEvent(OPEN_KEYBOARD_SHORTCUTS_EVENT));
    }
  };

  const renderUserItem = () => (
    <span className="profile-menu-trigger">
      <Avatar
        type="text"
        rounded="full"
        themeColor="primary"
        size="medium"
        className="profile-menu-avatar"
      >
        {initials}
      </Avatar>
      <span className="profile-menu-name">{user}</span>
    </span>
  );

  return user === '' || role === ''
    ? <></>
    : (
      <Menu onSelect={onSelect} openOnClick className="profile-wrapper">
        <MenuItem text={user} render={renderUserItem}>
          {role === Roles.Admin ? <MenuItem text="Documents" icon="file" data={{ route: routes.documents }} /> :<></>}
          {role === Roles.Admin ? <MenuItem text="Access" icon="unlock" data={{ route: routes.roles }} /> :<></>}
          {role === Roles.Admin ? <MenuItem text="Users" icon="tell-a-friend" data={{ route: routes.users }} /> :<></>}
          <MenuItem text="Keyboard shortcuts" icon="info-circle" data={{ action: 'shortcuts' }} />
          <MenuItem text="Log out" icon="logout" data={{ route: routes.signin }} />
        </MenuItem>
      </Menu>
  );
};

export default ProfileMenu;
